import React from "react";
import Headline from "./Headline";
import ContactAgents from "../../components/shared/ContactAgents";
import HomeLink from "../../widgets/HomeLink";

const bannerPath = '/iceholidays-assets/images/ice-visa-services_contact_agents.png';
const breadcrumbs = [
  { title: <HomeLink/>},
  { title: 'Visa Contact Agents' }
] 

class IceVisaContactAgentsPage extends React.Component {

  componentDidMount(): void {
    
  }
  

  render(){
    return (
      <div id="ice-visa-services-contact-agents-page" className="more-page">
        <Headline showSearch={false} bannerImage={bannerPath} breadcrumbs={breadcrumbs}>
          <span className="title">
            About
            <img src="/iceholidays-assets/images/ice_visa_services-logo.png" alt="Ice Visa Services Logo" />
          </span>
        </Headline>

        <ContactAgents type="Visa"/>
      </div>
    )
  }
}

export default IceVisaContactAgentsPage;